import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { IReceiptArgs } from 'src/common/interfaces/dtos/IReceiptArgs';
import { DigitalReceiptOptions } from 'src/common/interfaces/states/TenderingState';
import { store } from 'src/common/redux/configure-store';
import { generateActionButtons } from '../../business-logic/receipt-options-action-buttons';
import { ReceiptOptionsActionHandler } from '../../business-logic/receipt-options-action-handler';
import DigitalReceiptForm from './digital-receipt-form';
import { styles } from './print-receipt-options-styles';

export const getReceiptDetails = async (): Promise<IReceiptArgs> => {
  const span = createSpan('get-receipt-details');
  const receiptDetails = await ReceiptOptionsModal();
  endSpan(span);
  return receiptDetails;
};

export const ReceiptOptionsModal = async (): Promise<IReceiptArgs> => {
  return new Promise(resolve => {
    const message: IMessageModal = {
      message: 'PrintReceiptPrompt_Caption',
      type: EmeraldDialogTypes.InfoDecision,
      subMessage: 'ProduceReceiptPrompt_Message',
      onAccept: () => {},
      onCancel: () => {},
      acceptButtonLabel: '',
      closeButtonLabel: '',
      buttonComponent: (
        <PrintReceiptOptionsButtons
          digitalReceiptOptions={store.getState().tendering.digitalReceiptOptions}
          resolveHandler={ReceiptOptionsActionHandler.resolveHandler(resolve)}
        />
      ),
    };
    showEmeraldDialog(message);
  });
};

export const showDigitalReceiptOptions = (isAlsoPrintReceipt: boolean): Promise<IReceiptArgs> => {
  return new Promise<IReceiptArgs>(resolve => {
    pushEmeraldModal(
      <DigitalReceiptForm
        isAlsoPrintReceipt={isAlsoPrintReceipt}
        digitalReceiptOptions={store.getState().tendering.digitalReceiptOptions}
        transactionCustomer={store.getState().transaction.transactionCustomer}
        handleCancel={ReceiptOptionsActionHandler.digitalReceiptCancelHandler}
        handleConfirm={ReceiptOptionsActionHandler.digitalReceiptConfirmHandler}
        resolveHandler={ReceiptOptionsActionHandler.resolveHandler(resolve)}
      />,
    );
  });
};

interface ReceiptOptionButtonProps {
  digitalReceiptOptions: DigitalReceiptOptions;
  resolveHandler: (receiptDetails: IReceiptArgs) => void;
}
export const PrintReceiptOptionsButtons = ({
  resolveHandler,
  digitalReceiptOptions,
}: ReceiptOptionButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = styles();
  const actionButtons = generateActionButtons(resolveHandler, digitalReceiptOptions);

  return (
    <Grid container className={classes.dialogContent}>
      <Grid item>
        <BaseButton
          buttonType='white'
          className={`${classes.printButton} ${classes.closeButton}`}
          data-testid='receipt-dialog-cancel'
          onClick={() => ReceiptOptionsActionHandler.onCancel(resolveHandler)}
        >
          {t('None')}
        </BaseButton>
      </Grid>
      <Grid container item xs={9} justifyContent={'flex-end'}>
        {actionButtons &&
          actionButtons.map(
            (actionButton): JSX.Element => (
              <BaseButton
                buttonType='primary'
                className={`${classes.printButton}`}
                data-testid={actionButton.id}
                onClick={actionButton.handleClick}
                key={actionButton.id}
              >
                {t(actionButton.text)}
              </BaseButton>
            ),
          )}
      </Grid>
    </Grid>
  );
};
